import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Home } from "lucide-react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useLang } from "../i18n";

export default function NotFoundPage() {
  const { t } = useLang();

  useEffect(() => {
    document.title = "404 – Quattro Tavoli";
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="bg-[#FAF4EA] min-h-screen flex flex-col">
      <Navbar solid />

      <section className="flex-1 grid place-items-center px-6 pt-36 pb-24">
        <div className="text-center max-w-lg">
          <span className="font-display text-7xl font-700 text-[#9C3B2E]/25">404</span>
          <h1 className="mt-4 font-display text-3xl sm:text-4xl font-700 text-[#2A2420]">
            {t("notfound.title")}
          </h1>
          <p className="mt-4 text-[#6b6058] font-body leading-relaxed">
            {t("notfound.text")}
          </p>
          <Link
            to="/"
            className="mt-9 inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-[#9C3B2E] text-[#FAF4EA] font-500 tracking-wide hover:bg-[#9C3B2E] transition-all duration-300 hover:-translate-y-0.5"
          >
            <Home className="w-4 h-4" /> {t("notfound.cta")}
          </Link>
        </div>
      </section>

      <Footer />
    </main>
  );
}
